import React from 'react';
import './EventCalendar.css';

function EventCalendar({ date = new Date(), names = [] , headerText = "",topText = "", bottomText = "", calendar}) {
  // Ensure date is a Date object
  const parsedDate = new Date(date);

  // Determine the locale based on the country code
  const locale = calendar?.countryLocale || 'default';

  const firstDayOfMonth = new Date(parsedDate.getFullYear(), parsedDate.getMonth(), 1);
  const lastDayOfMonth = new Date(parsedDate.getFullYear(), parsedDate.getMonth() + 1, 0);
  const startingDay = (firstDayOfMonth.getDay() + 6) % 7;
  const totalDays = lastDayOfMonth.getDate();
  
  // Get month name and year using the determined locale
  const monthName = parsedDate.toLocaleString(locale, { month: 'long' });
  const year = parsedDate.getFullYear();

  // Generate calendar days
  const generateCalendarDays = () => {
    const days = [];
    // Add empty cells for days before the first day of month
    for (let i = 0; i < startingDay; i++) {
      days.push(<div key={`empty-${i}`} className="calendar-day empty"></div>);
    }
    
    // Add actual days
    for (let day = 1; day <= totalDays; day++) {
      const isHighlighted = day === parsedDate.getDate();
      days.push(
        <div 
          key={day} 
          className={`calendar-day ${isHighlighted ? 'highlighted' : ''}`}
        >
          {isHighlighted ? (
            <div className="heart-highlight">
              {day}
            </div>
          ) : day}
        </div>
      );
    }
    return days;
  };

  return (
    <div className="calendar-container">
      <div className="calendar-header">
        <h2>{ headerText }</h2>
        {names.length > 0 && (
          <h1 className="names">
            {names.length === 1 ? names[0] : `${names.slice(0, -1).join(', ')} & ${names[names.length - 1]}`}
          </h1>
        )}
        <p> {topText} </p>
      </div>
      <div className="calendar-spacing">
      <div className="calendar-header">
        <h2>{`${monthName} ${year}`}</h2>
      </div>
      <div className="calendar-weekdays">
        <div>{calendar?.days?.Mon || 'Mon'}</div>
        <div>{calendar?.days?.Tue || 'Tue'}</div>
        <div>{calendar?.days?.Wed || 'Wed'}</div>
        <div>{calendar?.days?.Thu || 'Thu'}</div>
        <div>{calendar?.days?.Fri || 'Fri'}</div>
        <div>{calendar?.days?.Sat || 'Sat'}</div>
        <div>{calendar?.days?.Sun || 'Sun'}</div>
      </div>
      <div className="calendar-grid">
        {generateCalendarDays()}
      </div>
      </div>
      <div className="calendar-header">
        <p> {bottomText} </p>
      </div>
    </div>
  );
}

export default EventCalendar; 